/** Apply SVG text fill via attribute + inline style so stylesheet rules cannot leave UA black. */
export function setSvgTextFill(text: SVGTextElement, fill: string): void {
  text.setAttribute('fill', fill);
  if (text.style) {
    text.style.fill = fill;
  }
}

/** Clear SVG text fill attribute and inline style. */
export function clearSvgTextFill(text: SVGTextElement): void {
  text.removeAttribute('fill');
  text.style?.removeProperty?.('fill');
}

/** Read current fill from inline style or presentation attribute. */
export function readSvgTextFill(text: SVGTextElement): string {
  return text.style?.fill || text.getAttribute('fill') || '';
}
